import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { connect } from 'react-redux';
import _ from 'lodash';

import AvisIntroduccioSeccioDadesMeteorCampNumeric from './avisIntroduccioSeccioDadesMeteorCampNumeric';
import AvisIntroduccioSeccioDadesMeteorCampLlista from './avisIntroduccioSeccioDadesMeteorCampLlista';
import AvisIntroduccioSeccioDadesMeteorCampText from './avisIntroduccioSeccioDadesMeteorCampText';
import AvisIntroduccioSeccioDadesMeteorCampFoto from './avisIntroduccioSeccioDadesMeteorCampFoto';
import { avisIntroduccioModificarValor, avisIntroduccioModificarUrlFotoAEliminar } from '../../actions';

/*
 Aixo son el tipus de camps que estàn configurats a la BBDD.
 */
const tipusDeCamps = {
	LL: (camp, onModificarValor) => <AvisIntroduccioSeccioDadesMeteorCampLlista key={camp.id} camp={camp} onModificarValor={onModificarValor} />,
	NM: (camp, onModificarValor) => <AvisIntroduccioSeccioDadesMeteorCampNumeric key={camp.id} camp={camp} onModificarValor={onModificarValor} />,
	TL: (camp, onModificarValor) => <AvisIntroduccioSeccioDadesMeteorCampText key={camp.id} camp={camp} onModificarValor={onModificarValor} />,
	FT: (camp, onModificarValor, modificarUrlFotoAEliminar) => <AvisIntroduccioSeccioDadesMeteorCampFoto key={camp.id} camp={camp} onModificarValor={onModificarValor} modificarUrlFotoAEliminar={modificarUrlFotoAEliminar} />
};

const renderCampSegonsTipus = (camp, onModificarValor, modificarUrlFotoAEliminar) => {
	return tipusDeCamps[camp.tipus] ? tipusDeCamps[camp.tipus](camp, onModificarValor, modificarUrlFotoAEliminar) : null;
};

class AvisIntroduccioSeccioDadesMeteorCamps extends Component {
	constructor(props) {
		super(props);
		this.onModificarValor = this.onModificarValor.bind(this);
	}

	onModificarValor(idCamp, valor) {
		this.props.avisIntroduccioModificarValor(idCamp, valor);
	}

	render() {
		const { campsMeteor, errorsValors, valors } = this.props;
		const temporalcamps = Object.values(campsMeteor).sort((a, b) => a.ordre - b.ordre);
		const componentsCamps = temporalcamps.map(valorsOrdenats => {
			let camp = _.cloneDeep(campsMeteor[valorsOrdenats.idCamp]);
			camp.id = valorsOrdenats.idCamp;
			camp.error = errorsValors[valorsOrdenats.idCamp];
			camp.valor = valors[valorsOrdenats.idCamp];

			return renderCampSegonsTipus(camp, this.onModificarValor, this.props.avisIntroduccioModificarUrlFotoAEliminar);
		});

		return <div className='avis-introduccio-seccio-dades-meteor-camps'>{componentsCamps}</div>;
	}
}

AvisIntroduccioSeccioDadesMeteorCamps.propTypes = {
	errorsValors: PropTypes.object.isRequired,
	campsMeteor: PropTypes.object.isRequired,
	valors: PropTypes.object.isRequired,
	avisIntroduccioModificarValor: PropTypes.func,
	avisIntroduccioModificarUrlFotoAEliminar: PropTypes.func
};

const mapStateToProps = state => {
	return {
		errorsValors: state.avis.formulari.errors.valors,
		valors: state.avis.formulari.dades.valors
	};
};

export default connect(
	mapStateToProps,
	{ avisIntroduccioModificarValor, avisIntroduccioModificarUrlFotoAEliminar }
)(AvisIntroduccioSeccioDadesMeteorCamps);



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteorCamps.js